export const ROOT_PATH = '/react-jsx-components';